module.exports = __webpack_public_path__ + "img/icon-cdk.dac01cbb.svg";